import {
  AccordionItem,
  List,
  Stack,
  Strong,
  Text,
  TextLink,
} from 'braid-design-system';
export const Integration = () => (
  <AccordionItem id="integration" label="Integration">
    <List type="number" start={3}>
      <Text>
        To integrate with the SEEK API, you must submit a request via our
        Integration form{' '}
        <TextLink href="/partners/integration-request/">here</TextLink> and meet
        our criteria for approval.
      </Text>
      <Stack space="medium">
        <Text>
          As part of your integration request, you will be required to provide
          the following information (in addition to any other information we may
          require from time to time):
        </Text>
        <List type="alpha">
          <Text>the name of your company;</Text>
          <Text>
            an e-mail address and phone number of the primary contact person;
            and
          </Text>
          <Text>
            such other information may be reasonably requested by us,
            (collectively, your <Strong>Identification Details</Strong>).
          </Text>
        </List>
      </Stack>
      <Text>
        It is your responsibility to ensure that your Identification Details
        always remain current.
      </Text>
      <Text>
        Once you have been approved for development, we will provide you with
        the necessary partner credentials.
      </Text>
      <Text>
        We do not guarantee that we will consent to the use and/or integration
        of your Recruitment Software. We may condition our consent to the use of
        your Recruitment Software on any number of factors including a
        modification of your Recruitment Software to a format or system more
        compatible with the SEEK API. We may work with you to achieve such an
        outcome, although we are under no obligation to do so.
      </Text>
      <Text>
        If you decide to terminate your use of the SEEK API in accordance with
        clause 53 of these Terms, your credentials will be terminated.
      </Text>
    </List>
  </AccordionItem>
);
